import { useNavigate } from "react-router-dom";
import { Container, Row, Col, Card, Form, Button } from "react-bootstrap";
import logoutImage from "../../assets/images/LogOut.png";

function LogOutMessage() {
  const navigate = useNavigate();
  return (
    <>
      <Container
        fluid
        className="d-flex justify-content-center align-items-center vh-100 px-3"
        style={{ backgroundColor: "#5a287d" }}
      >
        <div className="w-100 text-center">
          <div
            className="mx-auto shadow-lg rounded-4 p-4" // Bootstrap classes for styling
            style={{
              maxWidth: "400px",
              background: "#fff", // White background for contrast
              border: "1px solid #ccc", // Adds a light grey border
              boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)", // Soft shadow effect
              borderRadius: "12px", // Rounded corners
              padding: "20px",
            }}
          >
            <img
              src={logoutImage}
              alt="Logout"
              className="img-fluid mx-auto d-block mb-3"
              style={{ maxWidth: "80%", height: "auto" }} // Ensures image scales properly
            />

            <h2
              className="text-3xl font-bold"
              style={{ color: "#5a287d", wordWrap: "break-word" }}
            >
              Access Denied! 🚫
            </h2>

            <p
              style={{ color: "#5a287d", fontSize: "1rem", padding: "0 10px" }}
            >
              Oops! You need to log in to continue. Click the button below to
              get back in.
            </p>

            <Button
              className="buttonNatwest mt-3"
              style={{
                width: "100%",
                maxWidth: "200px",
                padding: "10px",
              }}
              onClick={() => navigate("/login")}
            >
              Login
            </Button>
          </div>
        </div>
      </Container>
    </>
  );
}

export default LogOutMessage;
